<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="login-bannerbox">
      <div class="mid">
        <div class="mianbao mt2">
          <span class="dq">当前位置：</span>
          <a href="javascript:void(0);" @click="toRouter('/main/home')" class="mba">个人中心</a> &gt;
          <a href="javascript:void(0);" @click="toRouter('/main/course')" class="mba">我的课程</a> &gt;
          <span class="site color text-primary">视频播放</span>
        </div>
        <div class="flexbox mb3">
          <div class="shipin color text-primary" :class="{ dis: !iLe.isFinished }">
            <video ref="videoBoxRef" id="videoPlayer" class="video-js vjs-fluid vjs-big-play-centered"
              style="width: 100%; height: 100%; " controls preload="auto" autoplay :loop="false"></video>
          </div>
          <div class="shipin_right">
            <div class="tabs">
              <div class="tab" :class="{ 'active': tab == 1 }" @click="tab = 1">目录</div>
              <div class="tab" :class="{ 'active': tab == 2 }" @click="tab = 2" v-if="info.isEvaluate == 1">提问互动</div>
            </div>
            <div class="tab-box" v-if="tab == 1">
              <div v-for="(z, i) in chapters" :key="i">
                <div class="spz" style="color: rgb(153, 153, 153);" @click="zShow(z)">
                  <span class="spz1">第 {{ i + 1 }} 章</span>
                  <span class="spz2 ">{{ z.name }}</span>
                  <img src="../assets/login/xiala.png" class="xiala2">
                </div>
                <div class="spzmx text-primary" v-show="z.show">
                  <div v-for="(l, li) in z.lessons" :key="l.id" class="spzmxli text-primary"
                    :class="{ 'color': l.id == iLe.id }" @click="cutVideo(l, i, li)">
                    <span class="hoverColor">{{ l.name }}
                      (
                      {{ (l.realityMinutes || l.minutes) ? (((l.readDuration || 0) / (l.realityMinutes || l.minutes) * 100).toFixed(1) >= 100 
                      ? '100%' 
                      : ((l.readDuration || 0) / (l.realityMinutes || l.minutes) * 100).toFixed(1) + '%') 
                      : '0%' }}
                      )
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-box" v-if="tab == 2">
              <div class="comment">
                <div v-for="item in commentList" class="comment-item">
                  <div class="comment-info">
                    <div class="label">{{ item.studentName }}：</div>
                    <div class="value">{{ item.content }}</div>
                  </div>
                  <div class="time">{{ item.createTime }}</div>
                  <div v-if="item.replyName" style="padding-left: 6px;">
                    <div class="comment-info" style="margin-top: 4px;">
                      <div class="label" style="color: red;">{{ item.replyName }}：</div>
                      <div class="value">{{ item.replyContent }}</div>
                    </div>
                    <div class="time">{{ item.replyTime }}</div>
                  </div>
                </div>
              </div>
              <div class="content">
                <el-input class="inp" size="mini" v-model="content"></el-input>
                <el-button size="mini" @click="handleSubmit">发送</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <camera v-if="info.openProcessCapture" ref="camera" type="kj" size="mini" @logPhoto_ok="logPhotoOk"
      @logPhoto_no="logPhotoNo" />
    <!--  -->
    <a href="https://www.whxunw.com/wechat-ai/#/" target="_blank" class="aiBox">
      <img src="../assets/AI_icon.png" alt="AI">
    </a>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "videojs-flvjs-es6";
export default {
  name: 'Login',
  components: {
    HeaderTop,
    Footer,
    camera: () => import("@/components/camera.vue"),
  },
  data() {
    return {
      loading: false,
      videoPlayer: null,
      info: {},
      chapters: [],
      onId: null,
      selectedLesson: {},
      studyCourse: {},
      iLe: {},
      zi: -1,
      li: -1,
      timerMark_zp: false, //抓拍_mark
      currentTime: 0,
      timerMark: false,
      zpTime: null,
      second: 0,
      tab: 1,
      content: '',
      commentList: [],
      continuousNoFaceCount: 0
    };
  },
  created() {
    this.getInfo()
    this.getComment()
  },
  mounted() {
  },
  destroyed() {
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
    }
    if (this.$refs.camera) {
      this.$refs.camera.close()
    }
    if (this.zpTime) {
      clearInterval(this.zpTime)
    }
  },
  methods: {
    getInfo() {
      this.$http.get('/student/pc/courseware/detail', this.$route.query).then(res => {
        this.chapters = res.chapters
        this.info = res
        if (res.openProcessCapture) {
          this.setTime()
        }
        this.setLive()
      })
    },
    setLive() {
      const _this = this
      if (_this.chapters) {
        _this.chapters.some((z, zi) => {
          return z.lessons.some((j, ji) => {
            if (!j.isFinished) {
              _this.zShow(z,true)
              console.log('setLive',j, zi, ji);
              _this.cutVideo(j, zi, ji)
              return true
            }
          })
        })
      }
    },
    setTime() {
      const _this = this
      if (this.zpTime) {
        clearInterval(this.zpTime)
      }
      this.zpTime = setInterval(() => {
        if (_this.zi == -1 && _this.li == -1) {
          return
        }
        this.$refs.camera.takePhoto({
          chapterId: _this.chapters[_this.zi].id,
          lessonId: _this.iLe.id,
          coursewareId: _this.info.id,
          examConfigId: _this.$route.query.examConfigId,
        });
      }, (60 * 1000)*(this.info.captureInterval||1))
    },
    logPhotoOk(res) {
      this.timerMark_zp = false
      // 人脸检测踢出逻辑
      if(this.info.kickVerify && this.info.kickVerify > 0){
        if(res.hasFace === 1){
          // 检测到人脸，重置连续未检测计数
          this.continuousNoFaceCount = 0
        }else{
          // 未检测到人脸，计数加1
          this.continuousNoFaceCount++
          // 达到踢出阈值
          if(this.continuousNoFaceCount >= this.info.kickVerify){
            setTimeout(() => {
              this.$alert(`连续${this.info.kickVerify}次未检测到人脸，请重新进入学习`,'提示');
            }, 500);
            this.$router.go(-1)
          }
        }
      }
    },
    logPhotoNo() {
      this.timerMark_zp = false
    },
    toRouter(path) {
      this.$router.push({ path })
    },
    zShow(z,s) {
      this.$set(z, 'show', s||!z.show)
    },
    cutVideo(j, zi, li) {
      if (this.zi == zi && this.li == li) {
        return
      }
      this.zi = zi
      this.li = li
      this.iLe = j
      const _this = this
      _this.initVideo(j.filePath, _this.getVideoFormatRegex(j.filePath), j)

    },
    // 判断视频后缀
    getVideoFormatRegex(url) {
      const videoFormatRegex = /\.(flv)$/i;
      const videoFormatRegex2 = /\.(m3u8)$/i;
      if (videoFormatRegex.test(url)) {
        return 'video/x-flv';
      } else if (videoFormatRegex2.test(url)) {
        return 'application/x-mpegURL';
      } else {
        return ''
      }
    },
    initVideo(src, type, j) {
      src = src.replace('http://','https://')
      var _this = this
      if (this.videoPlayer) {
        // 清除当前视频状态并重置播放器
        // this.videoPlayer.reset();
        // 通知video.js源已更改
        this.videoPlayer.src({ src, type });
        // 刷新播放器以使用新源
        this.videoPlayer.load();
        // 播放新视频
        // this.videoPlayer.play();
        if (_this.iLe.readDuration * 60 > 0) {
              _this.videoPlayer.currentTime(_this.iLe.readDuration * 60)
            }
        return
      }
      this.$nextTick(() => {
        const options = {
          // 初始化默认宽高，避免第一次加载闪一下
          height: 360,
          fullscreen: {
            options: { navigationUI: "hide" },
          },
          techOrder: ["html5", "flvjs"], // 兼容顺序
          // 配置支持播放hls格式视频流
          html5: {
            hls: {
              withCredentials: true,
            },
          },
          // 配置支持播放flv格式视频流
          flvjs: {
            mediaDataSource: {
              isLive: false,
              cors: true,
              withCredentials: false,
            },
          },
          sources: [
            {
              src,
              type,
            },
          ],
        };
        const videElement = document.getElementById(`videoPlayer`);
        _this.videoPlayer = videojs(videElement, options, function onPlayerReady() {
          videojs.log("播放器准备好了");
          if (_this.iLe.readDuration * 60 > 0) {
              _this.videoPlayer.currentTime(_this.iLe.readDuration * 60)
            }
          _this.videoPlayer.on('play', function () {//开始播放
            console.log("开始播放", _this.iLe)
            _this.second = 0
            
          });
          _this.videoPlayer.on('timeupdate', function () {
            _this.handlTimeUpdate()
          });
          _this.videoPlayer.on('ended', function () {//播放结束
            console.log("播放结束")
            _this.onEnded()
          });

        });

      });
    },
    async updateVideoPlay() {
      if (this.videoPlayer) {
        this.videoPlayer.dispose();
      }
      // const myVideoDiv = document.getElementById("videoPlayer");
      // myVideoDiv.innerHTML =
      //   '<video ref="videoBoxRef" id="videoPlayer" class="video-js vjs-fluid vjs-big-play-centered" style="width: 100%; height: 100%; " controls preload="auto" autoplay loop></video>';

    },
    handlTimeUpdate() {
      const second = parseInt(this.videoPlayer.currentTime());
      if (this.second == second) {
        return
      }
      this.second = second
      console.log(second, this.timerMark, this.iLe.readDuration, ((this.iLe.readDuration || 0) + 1) * 60, '当前播放时长');
      this.currentTime = second;
      if ((second > ((this.iLe.readDuration || 0) + 1) * 60) && !this.timerMark) {
        this.timerMark = true;
        this.achieve();
      }
    },
    onEnded() {
      console.log('onendend');
      this.setLive()
      this.achieve()
    },
    // 时长保存
    async achieve() {
      if (this.iLe.isFinished) {
        return
      }
      const self = this;
      self.$http.post_s("/student/pc/courseware/marker", {
        chapterId: self.chapters[self.zi].id,
        lessonId: self.iLe.id,
        coursewareId: self.info.id,
        examConfigId: self.$route.query.examConfigId,
      }).then(res => {
        const ci = (self.iLe.readDuration || 0) + 1
        self.$set(self.iLe, 'isFinished', !!res.isFinished)
        self.$set(self.iLe, 'readDuration', res.duration)
        console.log('achieve');
        if (res.isFinished) {
          self.setLive()
        }
      }).finally(() => {
        self.timerMark = false;
      })
      // self.$bvToast.toast("时长更新", {
      //   title: "提示",
      //   solid: true,
      //   toaster: "b-toaster-bottom-right",
      // });
    },
    getComment() {
      this.$http.get('/student/pc/study/comment/getComments', { coursewareId: this.$route.query.id })
        .then(res => {
          this.commentList = res
        })
    },
    handleSubmit() {
      if (!this.content) {
        this.$message({
          showClose: true,
          message: "内容不能为空",
          type: "error",
        });
        return
      }
      const params = { 
        coursewareId: this.$route.query.id,
        content: this.content
      }
      this.$http.post('/student/pc/study/comment/add', params).then(res => {
        this.content = ''
        this.getComment()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.login-bannerbox {
  padding-top: 90px;
  min-height: calc(100% - 200px);
}
::v-deep .dis .vjs-progress-control {
  visibility: hidden;
}
.mid {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.mianbao {
  line-height: 30px;
  padding: 15px 0;

  .dq {
    color: #666666;
    line-height: 30px;
    font-size: 14px;
    display: inline-block;
  }

  .mba {
    display: inline-block;
    color: #666666;
    line-height: 30px;
    font-size: 14px;
    padding: 0 5px;
  }

  .mba {
    display: inline-block;
    color: #666666;
    line-height: 30px;
    font-size: 14px;
    padding: 0 5px;
  }

  .site {
    color: #333333;
    display: inline-block;
    line-height: 30px;
    font-size: 14px;
    padding: 0 5px;
  }
}

.mb3 {
  margin-bottom: 30px !important;
}

.flexbox {
  display: flex;
  flex-flow: row;
  justify-content: space-around;

  .shipin {
    width: 830px;
    background-color: #262626;
    height: 530px;
  }

  .shipin_right {
    width: 370px;
    /* background-color: #131313; */
    // overflow-y: auto;
    height: 530px;
    box-sizing: border-box;
    padding: 0 24px;

    .tab-box {
      position: relative;
      height: 489px;
      overflow-y: auto;
    }

    .tabs {
      display: flex;
      justify-content: center;
      padding-bottom: 16px;
      color: #333;
      border-bottom: 1px solid #EAEAEA;

      .tab {
        flex: 1;
        text-align: center;
        cursor: pointer;
      }

      .active {
        position: relative;
        color: $primary;
        font-weight: bold;

        &::after {
          content: '';
          position: absolute;
          bottom: -17px;
          left: 50%;
          transform: translateX(-50%);
          width: 28px;
          height: 4px;
          background-color: $primary;
        }
      }
    }

    .comment {
      height: 461px;
      font-size: 14px;
      padding: 12px 0;
      overflow-y: auto;

      .comment-item {
        margin-bottom: 14px;

        .comment-info {
          display: flex;
          margin-bottom: 4px;

          .label {
            flex-shrink: 0;
            color: $primary;
          }

          .value {
            color: #333;
            word-break: break-all;
          }
        }

        .time {
          font-size: 14px;
          color: #888;
          line-height: 12px;
        }
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: absolute;
      bottom: 0;

      .inp {
        flex: 1;
        margin-right: 12px;
      }
    }

    .spz {
      font-size: 14px;
      line-height: 30px;
      color: #999999;
      cursor: pointer;
      padding-top: 10px;
    }

    .spz1 {
      display: inline-block;
      vertical-align: top;
      margin-right: 20px;
    }

    .spz2 {
      display: inline-block;
      vertical-align: top;
      max-width: 212px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .xiala2 {
      width: 20px;
      height: 20px;
      margin: 5px;
      float: right;
      transform: rotate(-90deg);
    }

    .spzmx {
      padding-top: 10px;
    }

    .spzmxli.color {
      background: url(../assets/login/bofang.png) no-repeat;
      background-size: 16px 14px;
      background-position: left 10px;
    }

    .spzmxli {
      padding-left: 24px;
      font-size: 12px;
      line-height: 34px;
      color: #999999;
      background: url(../assets/login/bofang2.png) no-repeat;
      background-size: 16px 14px;
      background-position: left 10px;
      cursor: pointer;
    }

    .hoverColor {
      color: rgb(51, 51, 51);

      &:hover {
        color: $primary;
      }
    }
  }
}
.text-primary {
  color: $primary;
}
.aiBox {
  position: fixed;
  bottom: 30%;
  right: calc(50% - 630px);
  width: 50px;
  height: 50px;
  z-index: 1000;
}
.aiBox img {
  width: 100%;
  height: 100%;
}
</style>
